import { render, staticRenderFns } from "./PublicidadInicial.vue?vue&type=template&id=3c521036&scoped=true"
import script from "./PublicidadInicial.vue?vue&type=script&lang=js"
export * from "./PublicidadInicial.vue?vue&type=script&lang=js"
import style0 from "./PublicidadInicial.vue?vue&type=style&index=0&id=3c521036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c521036",
  null
  
)

export default component.exports